export const CANVAS_FONT_FAMILY = '"Fredoka", system-ui, sans-serif';

export async function loadCanvasFonts(): Promise<void> {
  if (typeof document === "undefined" || !document.fonts) return;

  await Promise.all([
    document.fonts.load('400 16px "Fredoka"'),
    document.fonts.load('600 16px "Fredoka"'),
    document.fonts.load('700 16px "Fredoka"'),
  ]);
}
